import { SubscriptionsListDropdown } from '@modules/dashboard/components/subscription-list/SubscriptionListDropdown';
import clsx from 'clsx';
import { ReactNode } from 'react';

export type HeadlineProps = {
  type?: 'primary' | 'secondary' | 'neutral';
  children?: ReactNode;
  hasDropdown?: boolean;
  className?: string;
};

export const Headline = ({
  type = 'primary',
  children,
  hasDropdown = false,
  className,
}: HeadlineProps) => {
  return (
    <div
      className={clsx(
        'headline-wrapper flex flex-row flex-wrap',
        { 'text-primary': type === 'primary' },
        { 'text-secondary': type === 'secondary' },
        { 'text-[#4d4d4d] md:mb-[3rem]': type === 'neutral' },
        { '!justify-end': !children },
        className,
      )}>
      {children && <h2 className="inline-flex headline">{children}</h2>}

      {/* <div
        className={clsx(
          'headline-line',
          { 'headline-primary': type === 'primary' },
          { 'headline-secondary': type === 'secondary' },
          { 'headline-neutral': type === 'neutral' },
        )}
      ></div> */}

      {hasDropdown && (
        <div className="inline-flex justify-end md:hidden">
          <SubscriptionsListDropdown />
        </div>
      )}
    </div>
  );
};
